import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { TermsAndConditionsEffects } from './terms-and-conditions.effects';
import { ITermsAndConditionsFeature } from './terms-and-conditions.feature.state';
import { termsAndConditonsReducer } from './terms-and-conditions.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<ITermsAndConditionsFeature>('termsAndConditionsFeature'), termsAndConditonsReducer),
    EffectsModule.forFeature([TermsAndConditionsEffects]),
  ],
})
export class TermsAndConditionsStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: TermsAndConditionsStateModule
  ) {
    if (parentModule) {
      throw new Error('TermsAndConditionsStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
